import { configStore } from "@/store/store-accessor";
import { PopupTriggers } from "@/subapps/manage-templates/types";
import { Condition, RuleGroup, Trigger } from "@/types/conditions";
import { DynamicField } from "@/types/dynamic-data";

export function appendProToProConditionsLabelInFreeMode(
  label: string,
  condition: Condition
) {
  if (condition.proOnly) {
    return appendProToLabelInFreeMode(label);
  }

  return label;
}

export function appendProToLabelInFreeMode(label: string) {
  if (configStore.subscriptionMode === "free") {
    return `${label} [PRO]`;
  }

  return label;
}

export function areProConditionsUsedInRules(
  ruleGroups: RuleGroup[] | undefined | null,
  proOnlyConditions: Condition[]
) {
  return (
    ruleGroups &&
    proOnlyConditions.length &&
    ruleGroups
      .flat()
      .find(rule =>
        proOnlyConditions.find(condition => condition.slug === rule.ruleSlug)
      )
  );
}

export function areProPopupTriggersUsed(
  appliedTriggers: Trigger[],
  allPopupTriggers: PopupTriggers[]
) {
  const proOnlyTriggers = allPopupTriggers.filter(trigger => trigger.proOnly);

  return appliedTriggers.find(appliedTrigger =>
    proOnlyTriggers.find(
      proOnlyTrigger => proOnlyTrigger.value == appliedTrigger.slug
    )
  );
}

export function isDynamicFieldProOnlyAndUserIsOnFreeTier(field: DynamicField) {
  return configStore.subscriptionMode === "free" && field.proOnly;
}

export function getProBadge() {
  return {
    backgroundColor: "var(--gray200)",
    label: "Pro",
    textColor: "var(--gray800)"
  };
}
